import { render } from "./QuestionBackground.vue?vue&type=template&id=8e306f72"
import script from "./QuestionBackground.vue?vue&type=script&lang=js"
export * from "./QuestionBackground.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__